import React from 'react';

import { Box, Typography, Button } from '@mui/material';

import './NotePopups.scss';
import checkIcon from '../../../common/assets/icons/check_icon.svg';

type Props = {
  onClose: () => void;
};

const WelcomeNotePopup: React.FC<Props> = ({ onClose }) => {
  const [showPopup, setShowPopup] = React.useState(true);

  const hideThePopup = () => {
    setShowPopup(false);
    onClose();
  };

  return (
    <>
      {showPopup && (
        <Box className='note-popup green-border'>
          <div className='check-mark'>
            <img src={checkIcon} alt='CheckMark' style={{ width: 24 }} />
          </div>
          <Typography fontWeight={600} style={{ color: '#6FCF97' }}>
            Welcome to your 30-day free trial!
          </Typography>

          <Typography
            style={{ textAlign: 'center', marginTop: 8, marginBottom: 8 }}
          >
            You can access the app on iOS, Android or Web.
          </Typography>

          <Typography style={{ textAlign: 'center' }}>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            We've included 5 Note Scans and unlimited searches with the trial.
            Unused Note Scans expire when it ends.
          </Typography>

          <Button
            sx={{
              borderRadius: '20px',
              marginTop: '8px',
            }}
            onClick={() => hideThePopup()}
            color={'primary'}
            variant={'contained'}
          >
            <Typography color={'white'}>Ok</Typography>
          </Button>
        </Box>
      )}
    </>
  );
};

export default WelcomeNotePopup;
